import mixins from 'vue-typed-mixins'
import routeMixin from '@/router/routeMixin'
import globalMixin from '../globalMixin'
import { InfoFichier } from '@/domain/InfosFichier'
import Openable from '@/global/viewmodels/openable'
import Configuration from '@/configuration/configuration'
import { FilePartageParMailInput } from './input/FilePartageParMailInput'
import { Dossier } from '@/domain/Dossier'
import _ from 'lodash'
import { EnumPermission } from '@/domain/permission'

export default mixins(routeMixin, globalMixin).extend({
    data() {
        return {
            files: [] as InfoFichier[],
            dossiers: [] as Dossier[],
            dossierCourant: null as null | Dossier,
            dossierEdit: null as null | Dossier,
            file: null as null | File,
            fileInfo: null as null | InfoFichier,
            dialog: new Openable(),
            dialogPartage: new Openable(),
            dialogDossier: new Openable(),
            dialogUsersLies: new Openable(),
            partageParMail: null as null | FilePartageParMailInput
        }
    },
    methods: {
        loadFiles: function() {
            this.$loader.go()
            this.$http
                .api(`file/all`)
                .get()
                .then(x => {
                    this.files = x.data
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        loadDossiers() {
            this.$loader.go()
            this.$http
                .api(`dossier/all`)
                .get()
                .then(x => {
                    this.dossiers = x.data
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        ajouterFichier(file: File) {
            if (!file) return

            const formData = new FormData()
            formData.append('file', file, file.name)
            if (this.dossierCourant) formData.append('dossierId', this.dossierCourant.id.toString())

            this.$loader.go()
            this.$http
                .api(`file`)
                .post(formData)
                .then(x => {
                    this.openFileInfo(x.data)
                    this.loadFiles()
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        ajouterDossier() {
            this.dossierEdit = new Dossier()
            this.dossierEdit.dossierParentId = this.dossierCourant?.id || null
            this.dialogDossier.open()
        },
        openDossier(dossier: Dossier) {
            if (dossier.id == 0) this.dossierCourant = null
            else this.dossierCourant = dossier
        },
        beforeDossier() {
            this.dossierCourant = this.getPreviousFolder(this.dossierCourant)
        },
        getPreviousFolder(dossier_: Dossier | null) {
            if (dossier_?.dossierParentId) return _.find(this.dossiers, dossier => dossier.id === dossier_.dossierParentId) || null
            else return null
        },
        editDossier(dossier: Dossier) {
            this.dossierEdit = dossier
            this.dialogDossier.open()
        },
        save(file: InfoFichier | undefined) {
            if (!file && !this.fileInfo) return

            this.$loader.go()
            this.$http
                .api(`file`)
                .put(file || this.fileInfo)
                .then(x => {
                    this.loadFiles()
                    this.fileInfo = x.data
                    this.dialog.close()
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        saveDossier(dossier: Dossier | undefined) {
            if (!dossier && !this.dossierEdit) return

            this.$loader.go()
            this.$http
                .api(`dossier`)
                .post(dossier || this.dossierEdit)
                .then(x => {
                    this.loadDossiers()
                    this.loadFiles()
                    this.dossierEdit = null
                    this.dialogDossier.close()
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        inputFileTriggered() {
            const files = (this.$refs.uploader as HTMLInputElement)?.files
            console.log(files)
            if (files && files[0]) this.ajouterFichier(files[0])
        },
        openFileInfo(file: InfoFichier) {
            this.fileInfo = file
            this.dialog.open()
        },
        downloadFile(file: InfoFichier) {
            window.open(`${Configuration.apiUrl}/api/file/${file.identifiantTelechargement}`, '_blank')
        },
        deleteFile() {
            this.$swal.confirm.delete().then(a => {
                if (!a.isConfirmed) return
                if (!this.fileInfo) return
                this.$loader.go()
                this.$http
                    .api(`file`)
                    .deleteWithData(this.fileInfo.id)
                    .then(() => {
                        this.loadFiles()
                        this.dialog.close()
                        this.$swal.toast.success('Le fichier a bien été supprimé')
                    })
                    .catch(x => this.$swal.toast.errorApi(x))
                    .finally(() => this.$loader.stop())
            })
        },
        deleteDossier() {
            this.$swal.confirm.delete().then(a => {
                if (!a.isConfirmed) return
                if (!this.dossierEdit) return
                this.$loader.go()
                this.$http
                    .api(`dossier`)
                    .deleteWithData(this.dossierEdit.id)
                    .then(() => {
                        this.loadDossiers()
                        this.dialogDossier.close()
                        this.$swal.toast.success('Le dossier a bien été supprimé')
                    })
                    .catch(x => this.$swal.toast.errorApi(x))
                    .finally(() => this.$loader.stop())
            })
        },
        partagerFichierParMail() {
            if (!this.partageParMail) return
            if (!this.isFilled(this.partageParMail.mail)) return

            this.$swal.confirm.yesCancel('Partage fichier', 'Etes-vous sûr de vouloir partager ce fichier ?', 'Partager').then(a => {
                if (!a.isConfirmed) return

                this.$loader.go()
                this.$http
                    .api(`file/partage`)
                    .post(this.partageParMail)
                    .then(() => {
                        this.dialogPartage.close()
                        this.$swal.toast.success('Le fichier a bien été partagé par mail')
                    })
                    .catch(x => this.$swal.toast.errorApi(x))
                    .finally(() => this.$loader.stop())
            })
        },
    },
    mounted() {
        this.loadFiles()
        this.loadDossiers()
    },
    computed: {
        canShare: function() {
            console.log(this.$database.account.permissions)
            return this.$database.account.permissions.indexOf(EnumPermission.File_Share) !== -1
        },
        dossiersAffichable: function(): Dossier[] {
            return _.filter(this.dossiers, dossier => {
                return dossier.dossierParentId == this.dossierCourant?.id
            })
        },
        fichiersAffichables: function(): InfoFichier[] {
            return _.filter(this.files, file => {
                return file.dossierId == this.dossierCourant?.id
            })
        },
        breadCrumbDossiers(): Dossier[] {
            let dossierCourant = this.dossierCourant
            const dossier = new Dossier()
            dossier.id = 0
            dossier.nomDossier = 'Accueil'
            dossier.dossierParentId = null
            const breadCrumnb = []
            while (dossierCourant) {
                breadCrumnb.push(dossierCourant)
                dossierCourant = this.getPreviousFolder(dossierCourant)
                console.log(dossierCourant?.id, dossierCourant?.nomDossier, dossierCourant?.dossierParentId)
            }
            breadCrumnb.push(dossier)
            return _.reverse(breadCrumnb)
        }
    }
})
